__turbopack_context__.v({
  "header": "PrizeInputSection-module__c7eaBW__header",
  "subheading": "PrizeInputSection-module__c7eaBW__subheading",
});
